import { FormControl, Select, MenuItem, SelectChangeEvent } from '@mui/material';
import React from 'react';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { StyleObj } from '../../../../@types';

const styles: StyleObj = {
  formControl: {
    padding: '15px 15% 5px',
  },
  select: {
    borderRadius: 2,
    bgcolor: 'neutral.200',
    color: 'neutral.800',
    border: 'none',
    '& .MuiOutlinedInput-input': {
      py: 1,
    },
    '& .MuiSelect-icon': {
      borderLeft: '1px solid',
      borderColor: 'neutral.300',
      height: '100%',
      top: 0,
      paddingLeft: '8px',
      marginRight: '8px',
      fontSize: '2rem',
    },
  },
  menuItem: {
    backgroundColor: 'neutral.200',
    color: 'neutral.800',
    '&:hover': {
      backgroundColor: 'neutral.300',
    },
    '&.Mui-selected': {
      backgroundColor: 'primary.main',
      color: 'neutral.25',
      '&:hover': {
        backgroundColor: 'primary.main',
      },
    },
  },
};

interface StyledSelectProps {
  value: string | number | undefined;
  handleChange?: (event: SelectChangeEvent, child: React.ReactNode) => void;
  itemsList: { key: string | number; label: string }[];
}

const StyledSelect = ({ value, handleChange, itemsList }: StyledSelectProps) => {
  return (
    <FormControl fullWidth sx={styles.formControl}>
      <Select
        sx={styles.select}
        onChange={handleChange}
        displayEmpty
        IconComponent={KeyboardArrowDownIcon}
        value={value?.toString()}
      >
        {itemsList.map((item) => (
          <MenuItem key={item.key} value={item.key} sx={styles.menuItem}>
            {item.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export default StyledSelect;
